import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { fDateTimeM } from '../../../utils/formatTime';
import { fCurrency } from '../../../utils/formatNumber';

const styles = StyleSheet.create({
  title_container: {
    borderBottomColor: '#000',
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    margin: '3px 0 1px',
    fontWeight: 800
  }
});

export default function ReciboEnvio({ data, idQr }) {
  const {
    name_from,
    name_to,
    phone_from,
    phone_to,
    street_from,
    exterior_number_from,
    interior_number_from,
    colonia_from,
    street_to,
    exterior_number_to,
    interior_number_to,
    colonia_to,
    created_at,
    updated_at,
    city_from,
    city_to,
    email_from,
    email_to,
    zipcode_from,
    zipcode_to,
    label,
    trackingNumber,
    label_code,
    rate_provider,
    object_id,
    shippingValue,
    declared_value,
    seguro
  } = data;

  console.log(idQr);

  const dataUrl = document.getElementById(idQr).toDataURL();

  console.log(idQr, dataUrl);
  return (
    <Document>
      <Page size="A6">
        <View style={{ padding: '5px 10px 5px 10px', fontSize: '7.5px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '15px', justifyContent: 'space-between' }}>
            <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <Image src="/favicon/logo_negro.png" />
              <Text style={{ fontSize: '10px', textAlign: 'center' }}>Fecha: {fDateTimeM(updated_at)}</Text>
              {/* <Image src="/favicon/Logo_Negro_.svg" /> */}
            </View>
            {idQr && (
              <View style={{ marginLeft: '10px', marginRight: '10px' }}>
                <Image style={{ width: '60px', height: '60px' }} src={dataUrl} />{' '}
                <Text style={{ fontSize: '6px' }}>Escanear para rastrear</Text>
              </View>
            )}
          </View>
          {/* <View style={{ marginTop: '3px' }}>
            <Text>Fecha: {fDateTimeM(updated_at)}</Text>
          </View> */}
          <View style={styles.title_container}>
            <Text>Origen:</Text>
          </View>
          <View>
            <Text>{name_from}</Text>
            <Text>Tel. {phone_from}</Text>
            <Text>C.P. {zipcode_from}</Text>
            <Text>
              {street_from} {exterior_number_from} {interior_number_from || ''}
            </Text>
            <Text>{city_from}</Text>
            <Text>{colonia_from}</Text>
          </View>

          <View style={styles.title_container}>
            <Text>Destino:</Text>
          </View>
          <View>
            <Text>{name_to}</Text>
            <Text>Tel. {phone_to}</Text>
            <Text>C.P. {zipcode_to}</Text>
            <Text>
              {street_to} {exterior_number_to} {interior_number_to || ''}
            </Text>
            <Text>{city_to}</Text>
            <Text>{colonia_to}</Text>
          </View>

          <View style={{ marginTop: '3px' }}>
            <Text>Seguro: {seguro}</Text>
            {seguro === 'asegurado' && <Text>Valor del seguro: {declared_value}</Text>}
          </View>

          <View style={{ marginTop: '3px' }}>
            <Text>Código de rastreo Dagpacket: {object_id}</Text>
            <Text>
              {rate_provider} Track. Number: {label_code || trackingNumber || 'no number'}
            </Text>
          </View>

          {/* <View style={styles.title_container}>
            <Text>Facturación:</Text>
          </View>
          <View>
            <Text>Ingrese el numero de ID: {label_code || trackingNumber || 'no number'}</Text>
            <Text>Genere o consulte su factura en: https://dagpacket-plataforma.web.app</Text>
          </View> */}

          <View style={styles.title_container}>
            <Text style={{ fontWeight: 900 }}>Rastreo:</Text>
          </View>
          <View>
            <Text>
              Ingrese su código Dagpacket {object_id} para rastrear su paquete desde nuestra página:{' '}
              https://dagpacket-plataforma.web.app/rastreo
            </Text>
          </View>

          <View style={{ marginTop: '3px' }}>
            <View style={{ fontWeight: 800 }}>
              <Text>Precio: {fCurrency(shippingValue)}</Text>
            </View>
            <View style={{ marginTop: '3px' }}>
              <Text>
                Manifiesto bajo protesta de decir la verdad que la mercancía que ampara esta guía es legal y de
                procedencia licita. Por lo que deslindo a DAGPACKET de cualquier responsabilidad asumiendo total
                penalización jurídica, legal y las que resulten en caso de lo contrario
              </Text>
            </View>
            <View style={{ marginTop: '3px' }}>
              <Text>
                El manejo de los paquetes así como el traslado y tiempos de entrega son responsabilidad exclusivamente
                de la paquetería seleccionada, para mas información revise por favor los términos y condiciones en el
                siguiente link: https://dagpacket.com.mx/terminos-y-condiciones/
              </Text>
            </View>
          </View>

          <View style={{ margin: '3px 0 10px', fontSize: '10px', fontWeight: 800 }}>
            <Text>Nombre y Firma Cliente</Text>
          </View>

          <View style={{ marginTop: '20px', fontSize: '10px', fontWeight: 800 }}>
            <Text>GRACIAS POR SU ENVÍO</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
}
